import { alpha } from "@mui/material";

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// ***** For now we are only using PRIMARY and SECONDARY ****
//Delysium/SSO main color
const PRIMARY = {
  lighter: alpha("#FAE232", 0.6),
  light: alpha("#FAE232", 0.8),
  main: "#FAE232"
  // darker: "#005249",
};

const SECONDARY = {
  lighter: alpha("#FFFFFF", 0.6),
  light: alpha("#FFFFFF", 0.8),
  main: "#FFFFFF",
  dark: "#376965"
};

const INFO = {
  lighter: "#C8FACD",
  light: "#5BE584",
  main: "#000",
  dark: "#007B55",
  darker: "#005249"
};

const SUCCESS = {
  lighter: "#E9FCD4",
  light: "#AAF27F",
  main: "#68E094",
  dark: "#229A16",
  darker: "#08660D"
};

const WARNING = {
  lighter: "#FFF7CD",
  light: "#FFE16A",
  main: "#FF7C60",
  dark: "#B78103",
  darker: "#7A4F01"
};
const ERROR = {
  lighter: "#FFE7D9",
  light: "#FFA48D",
  main: "#FF7C60",
  dark: "#FF508F",
  darker: "#7A0C2E"
};

const GREY = {
  0: "#FFFFFF",
  10: alpha("#FFFFFF", 0.1),
  20: alpha("#FFFFFF", 0.2),
  30: alpha("#FFFFFF", 0.3),
  40: alpha("#FFFFFF", 0.4),
  50: alpha("#FFFFFF", 0.5),
  60: alpha("#FFFFFF", 0.6),
  70: alpha("#FFFFFF", 0.7),
  80: alpha("#FFFFFF", 0.8),
  90: alpha("#FFFFFF", 0.9),
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#929292",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#444444",
  700: "#4E4E4E",
  800: "#212B36",
  900: "#000",
  500_8: alpha("#000", 0.08),
  500_12: alpha("#000", 0.12),
  500_16: alpha("#000", 0.16),
  500_24: alpha("#000", 0.24),
  500_32: alpha("#000", 0.32),
  500_48: alpha("#000", 0.48),
  500_50: alpha("#000", 0.5),
  500_80: alpha("#000", 0.8)
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main)
};

const COMMON = {
  common: { black: "#000", white: "#fff" },
  primary: { ...PRIMARY, contrastText: "#fff" },
  secondary: { ...SECONDARY, contrastText: "#fff" },

  info: { ...INFO, contrastText: "#fff" },
  success: { ...SUCCESS, contrastText: GREY[800] },
  warning: { ...WARNING, contrastText: GREY[800] },
  error: { ...ERROR, contrastText: "#fff" },
  grey: GREY,
  gradients: GRADIENTS,
  divider: "#323232",
  action: {
    hover: alpha(PRIMARY.main, 0.8),
    selected: GREY[500_16],
    disabled: alpha(PRIMARY.main, 0.5),
    disabledBackground: alpha(PRIMARY.main, 0.5),
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
};

const palette = {
  // LIGHT MODE
  light: {
    ...COMMON,
    mode: "light",
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500]
    },
    background: {
      paper: "#fff",
      default: "#fff",
      dialog: "#070911",
      neutral: GREY[200]
    },
    action: {
      active: GREY[600],
      ...COMMON.action
    }
  },

  // DARK MODE
  dark: {
    ...COMMON,
    mode: "dark",
    text: {
      primary: GREY[0],
      secondary: alpha(GREY[0], 0.8),
      disabled: alpha(GREY[0], 0.7)
    },
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: GREY[500_16]
    },
    action: {
      active: GREY[500],
      ...COMMON.action
    }
  }
};

export default palette;
